/**
 * Centralized route definitions for the frontend.
 * Use these constants instead of hardcoding route strings.
 */

// App routes (internal navigation)
export const routes = {
  // Auth
  login: '/login',
  register: '/register',
  verifyEmail: '/verify-email',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',

  // Main app
  inbox: '/inbox',
  sent: '/sent',
  drafts: '/drafts',
  inTransit: '/in-transit',
  compose: '/compose',
  discover: '/discover',
  profile: '/profile',

  // Dynamic routes
  letter: (id: string) => `/letter/${id}`,
  user: (username: string) => `/user/${username}`,
  composeToUser: (userId: string) => `/compose?to=${userId}`,
  replyToLetter: (userId: string, letterId: string) => `/compose?to=${userId}&replyTo=${letterId}`,

  // Admin routes
  admin: {
    dashboard: '/admin',
    users: '/admin/users',
    user: (id: string) => `/admin/users/${id}`,
    reports: '/admin/reports',
    report: (id: string) => `/admin/reports/${id}`,
    letters: '/admin/letters',
    interests: '/admin/interests',
    sessions: '/admin/sessions'
  }
} as const;
